import MESSAGES from "@constants/messages.constants";
import { setAlertMessage } from "@reducers/alert.reducer";
import PermissionDeniedComponent from "@screens/permission-denied/permission-denied.component";
import { checkMenuAccess } from "@utils/menu-auth";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { getSettingFormInputs } from "../model/settings.modal";
import { menuUrl } from "../setting-list/setting.list.constants";
import SettingCreateTemplateComponent from "./setting.create.template";
import { createSettingApi } from "./setting.create.service";

const {
  ALERT_TYPES: { SUCCESS, ERROR },
  SETTINGS_ALERTS: { CREATE_ALERT },
} = MESSAGES;

const SettingCreateComponent = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const menuAccess = checkMenuAccess(menuUrl, "write");
  const [formTriggers, setFormTriggers] = useState({
    submitTrigger: 0,
    validationTrigger: 0,
  });

  const handleTriggerClick = (type) => {
    if (type === "SUBMIT") {
      setFormTriggers({
        ...formTriggers,
        submitTrigger: formTriggers.submitTrigger + 1,
      });
    }
  };
  const handleBackClick = () => {
    history.push(`/${menuUrl}`);
  };

  const handleSettingSubmit = async ({ values, errors }) => {
    // INFO : check for errors and return if errors found
    if (errors.length > 0) return;

    // INFO :  construct setting payload
    let settingPayload = {};
    for (let i = 0; i < values.length; i++) {
      settingPayload[values[i].name] = values[i].value;
    }

    // INFO : call edit api
    const settingResponse = await createSettingApi(settingPayload);
    console.log({settingResponse});

    // INFO : check api response and show relevant alert message
    if (settingResponse.status) {
      dispatch(setAlertMessage({ type: SUCCESS, message: CREATE_ALERT }));
      history.push(`/${menuUrl}`);
    } else {
      dispatch(
        setAlertMessage({ type: ERROR, message: settingResponse.message })
      );
    }
  };

  const templateModal = {
    formTriggers,
    formInputs: getSettingFormInputs({}),
  };

  const templateEvents = {
    handleSettingSubmit,
    handleTriggerClick,
    handleBackClick,
  };

  return menuAccess ? (
    <SettingCreateTemplateComponent
      templateModal={templateModal}
      templateEvents={templateEvents}
    />
  ) : (
    <PermissionDeniedComponent />
  );
};

export default SettingCreateComponent;
